export default function PHP_gethostbynamel() {
  return (
    <div>
      <h1>PHP_gethostbynamel</h1>
    </div>
  );
}
